import CustomView from "../custom-view/custom-view";
import {ModelInterface} from "../../data-structures/collection"
import NavigationLocalSettings from "./navigation-local-settings"
import {
    NavigationButtonPosition,
    NavigationButtonPositionDictionary,
    NavigationButtonPositionIcon,
    NavigationSectionConfig,
    NavigationSectionType
} from "./@const"
import ProjectSession from "../project/project-session"
import {PinLocation, PinLocationTypes} from "../pin/@types"
import {SpaceProto} from "../space/space-proto"
import {PopoverMenuItemType} from "../../gd-components/popover-menu/popover-menu/const"
import navigation_setPositionNew from "../../../layout/navigation/actions/set-navigation-position-new"
import PersonalView from "../view/personal-view/personal-view"
import {PersonalViewLocation} from "../view/personal-view/@types"

export default class NavigationSection implements ModelInterface {

    id                          : string
    icon?                       : string
    iconActive?                 : string
    iconSettings?               : string                    // used in Navigation Settings page (no size styles)
    name?                       : string
    customView?                 : CustomView
    personalView?               : PersonalView
    workspace?                  : ProjectSession
    hint?                       : string
    menuComponent?              : any
    menuContent?                : any // component that has menuComponent contnet - used in asana skin
    renderComponent             : any
    onClick?                    : callback
    position                    : NavigationButtonPosition
    sortPosition                : number = 0
    url?                        : string                    // used for apps pinned to panel
    space?                      : SpaceProto                // is set by SpaceProto.initNavigation

    moreOptions                 : func // {(props?: any):Option[] | undefined}  // function that returns options for hint more button popover (function because options may be modified during runtime)

    private _hintButtons?       : func                                   // this is func (!) used to render button more inside the hint

    keyboardShortcut?           : string

    navigationLocalSettings     : NavigationLocalSettings = new NavigationLocalSettings()

    type?                       : NavigationSectionType  // type used only for 'separator' at the moment

    public hiddenToMore         : boolean = false       // if true - it will appear in more because of lack of space
    public isLastInRenderGroup  : boolean = false       // used in render only to mark last button and dont' do margin

    public canChangeLocation    : boolean = true        // is used in navigation more to decide whether to show pin button or not

    constructor(config:NavigationSectionConfig) {
        this.id                 = _.get(config,'id')
        this.icon               = _.get(config,'icon')
        this.iconActive         = _.get(config,'iconActive')
        this.iconSettings       = _.get(config, 'iconSettings', this.icon)

        this.customView         = _.get(config,'customView')
        this.personalView       = _.get(config,'personalView')

        // old - deprecated
        this.workspace          = _.get(config,'workspace')
        // this.space              = _.get(config,'space')


        this.hint               = _.get(config,'hint')
        this.menuComponent      = _.get(config,'menuComponent')
        this.menuContent        = _.get(config,'menuContent')
        this.renderComponent    = _.get(config,'renderComponent')
        this.onClick            = _.get(config,'onClick')
        this.position           = _.get(config,'position', NavigationButtonPosition.TOP)
        this.sortPosition       = _.get(config,'sortPosition', 0)
        this.url                = _.get(config,'url')
        this.moreOptions        = _.get(config,'moreOptions', () => { return undefined })
        this._hintButtons       = _.get(config,'hintButtons')
        this.keyboardShortcut   = _.get(config,'keyboardShortcut')
        this.canChangeLocation  = _.get(config,'canChangeLocation', true)

        // last becuase of hint
        this.name               = _.get(config,'name', this.hint)

        this.type               = _.get(config, 'type', undefined)

    }

    get positionOptions():Option[] {

        let moreOptions : Option[] = []

        const setDisplayPosition = async (position:NavigationButtonPosition) => {
            navigation_setPositionNew(this, position)
        }

        if (this.space && _.size(this.space.positions) > 0) {
            moreOptions.push({
                type        : PopoverMenuItemType.HEADER,
                label       : 'Display In:'
            })

            _.map(this.space.positions, (position : NavigationButtonPosition)=>{
                moreOptions.push({
                    label       : NavigationButtonPositionDictionary[position],
                    icon        : NavigationButtonPositionIcon[position],
                    value       : position,
                    isSelected  : this.position === position,
                    onClick     : () => setDisplayPosition(position)
                })
            })

            return moreOptions
        }

        if (this.customView) {
            return this.customView.moreOptions()
        }

        if (this.personalView) {
            return this.personalView.menuMoreOptions()
        }

        const sectionMoreOptions = this.moreOptions()
        if (sectionMoreOptions && _.size(sectionMoreOptions) > 0) {
            return sectionMoreOptions
        }

        return moreOptions
    }

    get defaultAppUrl():string | undefined {
        // console.log("get defaultAppUrl()", this.id, this.navigationLocalSettings._sectionsLatestAppUrl)
        const url = this.navigationLocalSettings.getSectionLatestAppUrl(this.id)

        // patch for My Work and Notifications
        if (url?.includes('notifications')  && gd.user.settings.views.notifications.displayIn === NavigationSectionType.NAVIGATION_PANEL) return undefined
        if (url?.includes('my-work')        && gd.user.settings.views.myWork.get(gd.companyId)?.displayIn === NavigationSectionType.NAVIGATION_PANEL) return undefined

        return url
    }

    set defaultAppUrl(appUrl:string|undefined) {
        // console.log("set defaultAppUrl()", this.id, appUrl)
        this.navigationLocalSettings.setSectionLatestAppUrl(this.id, appUrl)
    }

    get height():number {
        switch (this.type) {
            case NavigationSectionType.SEPARATOR:
                return 10 /*margin-top*/ + 1 /*height*/ + 10 /*margin-bottom*/
            case NavigationSectionType.MORE:
            default:
                return gd.ui.navbarButtonSize
        }
    }

    get width(): number {
        switch (this.type) {
            case NavigationSectionType.SEPARATOR:
                return 1 /*width*/ + 12 /*margin-right*/
            case NavigationSectionType.MORE:
            default:
                return gd.ui.navbarButtonSize
        }
    }

    // get height():number {
    //
    //     // logo 25 20 15
    //     // item = 38 + 8
    //     // separator = 10 + 2 + 1
    //
    //     switch (this.type) {
    //         case NavigationSectionType.MORE:
    //             return 38 /*height*/ + 8 /*margin-bottom*/
    //         case NavigationSectionType.SEPARATOR:
    //             return 2 /*margin-top*/ + 1 /*height*/ + 10 /*margin-bottom*/
    //         default:
    //             // if (this.isLastInRenderGroup) return 38
    //             // else return 38 /*height*/ + 8 /*margin-bottom*/
    //
    //             return 38 /*height*/ + 8 /*margin-bottom*/
    //     }
    // }
    //
    // get width(): number {
    //     // logo 20 26 22
    //     // item = 38 + 12
    //     // separator = 10 + 1 + 10
    //
    //     switch (this.type) {
    //         case NavigationSectionType.MORE:
    //             return 38 /*width*/ + 12 /*margin-right*/
    //         case NavigationSectionType.SEPARATOR:
    //             return 10 /*margin-left*/ + 1 /*width*/ + 10 /*margin-right*/
    //         default:
    //             // if (this.isLastInRenderGroup) return 38
    //             // else return 38 /*width*/ + 12 /*margin-right*/
    //
    //             return 38 /*width*/ + 12 /*margin-right*/
    //     }
    // }

    get hintButtons(): func | undefined {

        if (!this._hintButtons) return undefined


        return (props: any) => {
            return this._hintButtons!(this.moreOptions(), props)
        }
    }

    get pinLocation() {
        let pinsLocation: PinLocation
        if (this.workspace) {
            pinsLocation = {
                type: PinLocationTypes.WORKSPACE,
                value: this.workspace.id
            }
        } else {
            pinsLocation = {
                type: PinLocationTypes.HOME,
            }
        }

        return pinsLocation
    }

    get isInMore() {
        return this.hiddenToMore || this.position === NavigationButtonPosition.MORE /*|| this.customView?.location === NavigationSectionType.MORE*/
    }

    get isInNavigation() {
        return this.customView?.location === NavigationSectionType.NAVIGATION_PANEL ||
               this.personalView?.location === PersonalViewLocation.NAVIGATION_PANEL
    }

    toJSON() {
        return {}
    }


}
